<div class="se-app__sub-footer">
  <div>
    <a href="https://www.sportsengine.com/privacy-center/terms-of-use/"
      class="pl-link"
      target="_blank">Terms of Use</a> |
    <a href="https://www.sportsengine.com/privacy-center/privacy-policy/"
      class="pl-link"
      target="_blank">
      Privacy Policy
    </a>
  </div>
  <div>
    <a href="https://www.versantprivacy.com/privacy/notrtoo?brandA=SportsEngine&intake=SportsEngine"
    class="pl-link"
    target="_blank">Do Not Sell My Personal Information</a>
  </div>
  <div>
    &copy; SportsEngine, LLC, All Rights Reserved
  </div>
</div>
